import { useQuery } from "urql";

import { GetDatabaseMetadataDocument } from "../../graphql/generated.ts";

export function useDatabaseMetadata() {
  return useQuery({
    query: GetDatabaseMetadataDocument,
  });
}
